export default {
  GET_OVERFLOW30MM_RAINBEFORE1HOUR: 'GET_OVERFLOW30MM_RAINBEFORE1HOUR',
  GET_OVERFLOW50MM_RAINBEFORE3HOUR: 'GET_OVERFLOW50MM_RAINBEFORE3HOUR'
}
